module.exports = __webpack_public_path__ + "img/fukushima_hamatsu.942e5c8c.jpg";